import {
    useNavigation,
    useRoute
} from '@react-navigation/native';
import {
    useCallback,
    useRef
} from 'react';
import { Platform } from 'react-native';

import actions from '../../actions';
import { AppHeader } from '../../combo';
import {
    Alert,
    Icon,
    Page,
    showNotification,
    TabSelector,
    View
} from '../../common';
import { showImagePickerModal } from '../../common/Modal';
import {
    getIsFetching,
    getPrefsLoadingState
} from '../../selectors';
import { DocumentsConsents } from './DocumentsConsents';
import { DocumentsPhoto } from './DocumentsPhoto';

const isWeb = Platform.OS === 'web';

export const Documents = Page.register(
    ({
        isFetching,
        isLoading,
    }) => {
        const { setParams } = useNavigation();
        const { params } = useRoute();
        const isAddingPhoto = useRef(false);

        const addDocumentHandler = useCallback(async () => {
            if (!isAddingPhoto.current) {
                isAddingPhoto.current = true;
                const showImgPicker = (item) => {
                    if (item.error) {
                        Alert.alert(Object.R('titles.error'), Object.R('titles.errorAddDocuments'));
                        isAddingPhoto.current = false;
                    } else {
                        item.assets?.forEach((el) => {
                            actions.addDocument({
                                ...el,
                                exists: true,
                            });
                        });
                        setTimeout(() => {
                            showNotification('titles.localFileAdded');
                            isAddingPhoto.current = false;
                        }, 2000);
                    }
                };
                const onCancel = () => {
                    isAddingPhoto.current = false;
                };
                showImagePickerModal(showImgPicker, onCancel);
            }
        }, []);

        const tabItems = [
            {
                id: 'photo',
                name: Object.R('titles.DocumentsPhoto'),
            },
            {
                id: 'consents',
                name: Object.R('titles.DocumentsConsents'),
            },
        ];

        // For web, always show consents tab
        const filter = isWeb ? 'consents' : (params?.filter ?? tabItems[0].id);

        return (
            <Page
                name="documents"
                // noscroll
                safeArea
                footer={
                    filter === 'photo' && !isWeb && (
                        <View
                            style={{
                                position: 'absolute',
                                bottom: 20,
                                right: 20,
                            }}
                            pointerEvents="box-none"
                        >
                            <Icon.Add
                                style={{
                                    width: 45,
                                    height: 45,
                                    borderRadius: 90,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderColor: '#18B797',
                                    backgroundColor: '#18B797',
                                }}
                                color="#FFFFFF"
                                onPress={addDocumentHandler}
                            />
                        </View>
                    )
                }
            >
                {!isWeb && (
                    <TabSelector
                        items={tabItems}
                        selected={filter}
                        onItem={(item) => {
                            setParams({ filter: item.id });
                        }}
                        outerStyles={{

                            backgroundColor: '#f2f2f2',
                            paddingHorizontal: 0,
                        }}
                    />
                )}
                {filter === 'photo' && !isWeb && (
                    <DocumentsPhoto
                        isFetching={isFetching}
                        isLoading={isLoading}
                    />
                )}
                {filter === 'consents' && <DocumentsConsents/>}
            </Page>
        );
    },
    {
        isFetching: { from: getIsFetching },
        isLoading: { from: getPrefsLoadingState },
    },
    { header: () => <AppHeader/> },
);
